export default __webpack_public_path__ + "static/myanmar-4d9bec28f2716a704b9663c36d07cd3a.svg";